// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./FormTypeManagementPage.css";

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   contributes_to_performance: false,
//   display_order: "",
// };

// export default function FormTypeManagementPage() {
//   const { can } = usePermissions();

//   const [formTypes, setFormTypes] = useState([]);
//   const [total, setTotal] = useState(0);

//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [systemFilter, setSystemFilter] = useState("");
//   const [performanceFilter, setPerformanceFilter] = useState("");

//   const [sortField, setSortField] = useState("display_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [editIsSystem, setEditIsSystem] = useState(false);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchFormTypes();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, statusFilter, systemFilter, performanceFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchFormTypes = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/form-types", {
//         params: {
//           search: search || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           is_system: systemFilter === "" ? undefined : systemFilter,
//           contributes_to_performance: performanceFilter === "" ? undefined : performanceFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setFormTypes(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch form types error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch form types");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setEditIsSystem(false);
//     setShowModal(true);
//   };

//   const openEdit = (formType) => {
//     setForm({
//       name: formType.name || "",
//       code: formType.code || "",
//       description: formType.description || "",
//       contributes_to_performance: !!formType.contributes_to_performance,
//       display_order: formType.display_order ?? "",
//     });
//     setEditId(formType.id);
//     setEditIsSystem(!!formType.is_system);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setEditIsSystem(false);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Form type name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       description: form.description.trim() || null,
//       contributes_to_performance: form.contributes_to_performance,
//       display_order: form.display_order === "" ? 0 : Number(form.display_order),
//     };

//     if (!editId) {
//       payload.code = form.code.trim() || undefined;
//     }

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/form-types/${editId}`, payload);
//         toast.success("Form type updated");
//       } else {
//         await api.post("/form-types", payload);
//         toast.success("Form type created");
//       }
//       closeModal();
//       fetchFormTypes();
//     } catch (err) {
//       console.error("Save form type error:", err);
//       toast.error(err.response?.data?.message || "Failed to save form type");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (formType) => {
//     try {
//       await api.patch(`/form-types/${formType.id}/status`, { is_active: !formType.is_active });
//       toast.success(formType.is_active ? "Form type deactivated" : "Form type activated");
//       fetchFormTypes();
//     } catch (err) {
//       console.error("Toggle form type status error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const openDeleteModal = (formType) => {
//     setDeleteTarget(formType);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/form-types/${deleteTarget.id}`);
//       toast.success("Form type deleted");
//       closeDeleteModal();
//       fetchFormTypes();
//     } catch (err) {
//       console.error("Delete form type error:", err);
//       const data = err.response?.data;
//       if (data?.code === "FORM_TYPE_IN_USE") {
//         toast.error(`Cannot delete: ${data.details?.forms || 0} form(s) use this type. Deactivate instead.`);
//       } else if (data?.code === "FORM_TYPE_SYSTEM_PROTECTED") {
//         toast.error("This form type is protected and cannot be deleted.");
//       } else {
//         toast.error(data?.message || "Failed to delete form type");
//       }
//       closeDeleteModal();
//     }
//   };

//   return (
//     <div className="unit-page formtype-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Form Type Management</h2>
//           <p>
//             Configure the types of forms available across the system. <strong>UAT is represented here as a form
//             type</strong> ("User Acceptance Testing") — not a separate module; UAT forms are simply forms whose
//             type is UAT, managed through the same Forms page.
//           </p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchFormTypes}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="form_types" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Form Type
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="formtype-stat-icon formtype-stat-icon-primary">
//             <i className="fa-solid fa-shapes" aria-hidden="true"></i>
//           </div>
//           <div className="formtype-stat-text">
//             <span>Total Form Types</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="formtype-stat-icon formtype-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="formtype-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-list-check formtype-list-icon" aria-hidden="true"></i>
//               Form Type List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete form types.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 240 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 170 }}
//               value={systemFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setSystemFilter(e.target.value);
//               }}
//             >
//               <option value="">System: Any</option>
//               <option value="1">System only</option>
//               <option value="0">Non-system only</option>
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 190 }}
//               value={performanceFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPerformanceFilter(e.target.value);
//               }}
//             >
//               <option value="">Performance: Any</option>
//               <option value="1">Contributes to performance</option>
//               <option value="0">Does not contribute</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading form types...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
//                   <th className="sortable" onClick={() => handleSort("contributes_to_performance")}>Performance {sortIcon("contributes_to_performance")}</th>
//                   <th>System</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {formTypes.length > 0 ? (
//                   formTypes.map((formType) => (
//                     <tr key={formType.id}>
//                       <td>
//                         <strong>{formType.name}</strong>
//                         {formType.code === "UAT" && <Badge bg="info" className="ms-2">UAT</Badge>}
//                       </td>
//                       <td>
//                         {formType.code}
//                         {formType.is_system && (
//                           <>
//                             <br />
//                             <small className="text-muted">Code is protected — cannot be changed</small>
//                           </>
//                         )}
//                       </td>
//                       <td>
//                         {formType.contributes_to_performance ? <Badge bg="warning" text="dark">Yes</Badge> : <span className="text-muted">No</span>}
//                       </td>
//                       <td>
//                         {formType.is_system ? <Badge bg="secondary">System</Badge> : "—"}
//                       </td>
//                       <td>
//                         <Badge bg={formType.is_active ? "success" : "secondary"}>
//                           {formType.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="form_types" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${formType.name || "form type"}`}
//                               onClick={() => openEdit(formType)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("form_types", "activate") || can("form_types", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn"
//                               title={formType.is_active ? "Deactivate" : "Activate"}
//                               aria-label={
//                                 formType.is_active
//                                   ? `Deactivate ${formType.name || "form type"}`
//                                   : `Activate ${formType.name || "form type"}`
//                               }
//                               onClick={() => toggleStatus(formType)}
//                               disabled={formType.is_system && formType.is_active}
//                             >
//                               <i className={`fa-solid ${formType.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="form_types" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title={formType.is_system ? "Protected — cannot be deleted" : "Delete"}
//                               aria-label={
//                                 formType.is_system
//                                   ? "Protected — cannot be deleted"
//                                   : `Delete ${formType.name || "form type"}`
//                               }
//                               onClick={() => openDeleteModal(formType)}
//                               disabled={formType.is_system}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-list-check" aria-hidden="true"></i>
//                         </div>
//                         <h5>No form types found</h5>
//                         <p>Try another search or add a new form type.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{formTypes.length}</strong> of <strong>{total}</strong> form types
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeModal} centered className="unit-modal" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{editId ? "Edit Form Type" : "Add New Form Type"}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Requirement Sign-off"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
//               <Form.Control
//                 placeholder="e.g. REQUIREMENT_SIGNOFF"
//                 value={form.code}
//                 disabled={!!editId}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//               {editIsSystem && <Form.Text className="text-danger">This is a protected system form type.</Form.Text>}
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Display Order</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.display_order}
//                 onChange={(e) => handleChange("display_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-8">
//               <Form.Check
//                 type="checkbox"
//                 label="Contributes to performance metrics"
//                 checked={form.contributes_to_performance}
//                 onChange={(e) => handleChange("contributes_to_performance", e.target.checked)}
//               />
//               <Form.Text muted>
//                 Only controls whether a FUTURE submission of this form type may affect performance metrics — no
//                 score is ever calculated or applied automatically merely because this is checked.
//               </Form.Text>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Form Type" : "Create Form Type"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showDeleteModal} onHide={closeDeleteModal} centered className="unit-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Form Type</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If forms reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "./FormTypeManagementPage.css";

const initialForm = {
  name: "",
  code: "",
  description: "",
  contributes_to_performance: false,
  display_order: "",
};

export default function FormTypeManagementPage() {
  const { can } = usePermissions();

  const [formTypes, setFormTypes] = useState([]);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [systemFilter, setSystemFilter] = useState("");
  const [performanceFilter, setPerformanceFilter] = useState("");

  const [sortField, setSortField] = useState("display_order");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [editIsSystem, setEditIsSystem] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchFormTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter, systemFilter, performanceFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchFormTypes = async () => {
    try {
      setLoading(true);
      const res = await api.get("/form-types", {
        params: {
          search: search || undefined,
          is_active: statusFilter === "" ? undefined : statusFilter,
          is_system: systemFilter === "" ? undefined : systemFilter,
          contributes_to_performance: performanceFilter === "" ? undefined : performanceFilter,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setFormTypes(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch form types error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch form types");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setEditIsSystem(false);
    setShowModal(true);
  };

  const openEdit = (formType) => {
    setForm({
      name: formType.name || "",
      code: formType.code || "",
      description: formType.description || "",
      contributes_to_performance: !!formType.contributes_to_performance,
      display_order: formType.display_order ?? "",
    });
    setEditId(formType.id);
    setEditIsSystem(!!formType.is_system);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setEditIsSystem(false);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Form type name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      description: form.description.trim() || null,
      contributes_to_performance: form.contributes_to_performance,
      display_order: form.display_order === "" ? 0 : Number(form.display_order),
    };

    if (!editId) {
      payload.code = form.code.trim() || undefined;
    }

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/form-types/${editId}`, payload);
        toast.success("Form type updated");
      } else {
        await api.post("/form-types", payload);
        toast.success("Form type created");
      }
      closeModal();
      fetchFormTypes();
    } catch (err) {
      console.error("Save form type error:", err);
      toast.error(err.response?.data?.message || "Failed to save form type");
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (formType) => {
    try {
      await api.patch(`/form-types/${formType.id}/status`, { is_active: !formType.is_active });
      toast.success(formType.is_active ? "Form type deactivated" : "Form type activated");
      fetchFormTypes();
    } catch (err) {
      console.error("Toggle form type status error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const openDeleteModal = (formType) => {
    setDeleteTarget(formType);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/form-types/${deleteTarget.id}`);
      toast.success("Form type deleted");
      closeDeleteModal();
      fetchFormTypes();
    } catch (err) {
      console.error("Delete form type error:", err);
      const data = err.response?.data;
      if (data?.code === "FORM_TYPE_IN_USE") {
        toast.error(`Cannot delete: ${data.details?.forms || 0} form(s) use this type. Deactivate instead.`);
      } else if (data?.code === "FORM_TYPE_SYSTEM_PROTECTED") {
        toast.error("This form type is protected and cannot be deleted.");
      } else {
        toast.error(data?.message || "Failed to delete form type");
      }
      closeDeleteModal();
    }
  };

  return (
    <div className="unit-page formtype-mgmt-theme">

      <div className="formtype-heading-box">
        <div className="formtype-heading-content">
          <div className="formtype-heading-icon">
            <i className="fa-solid fa-shapes" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Form Type Management</h2>
            <p>
              Configure the types of forms available across the system. <strong>UAT is represented here as a form
              type</strong> ("User Acceptance Testing") — not a separate module; UAT forms are simply forms whose
              type is UAT, managed through the same Forms page.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchFormTypes}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="form_types" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Form Type
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card formtype-stat-blue">
          <div className="formtype-stat-content">
            <div className="formtype-stat-text">
              <span>Total Form Types</span>
              <strong>{total}</strong>
            </div>

            <div className="formtype-stat-icon">
              <i className="fa-solid fa-shapes" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card formtype-stat-purple">
          <div className="formtype-stat-content">
            <div className="formtype-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="formtype-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card formtype-stat-green">
          <div className="formtype-stat-content">
            <div className="formtype-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="formtype-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar formtype-toolbar">
          <div className="formtype-section-title">
            <div className="formtype-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="formtype-section-copy">
              <h5>Form Type List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete form types.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions formtype-filters-row">
            <InputGroup className="unit-search formtype-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="formtype-select-wrap">
              <i className="fa-solid fa-circle-check formtype-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="formtype-filter-select"
                value={statusFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusFilter(e.target.value);
              }}
            >
              <option value="">All Statuses</option>
              <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <div className="formtype-select-wrap">
              <i className="fa-solid fa-shield-halved formtype-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="formtype-filter-select"
                value={systemFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setSystemFilter(e.target.value);
              }}
            >
              <option value="">System: Any</option>
              <option value="1">System only</option>
                <option value="0">Non-system only</option>
              </Form.Select>
            </div>

            <div className="formtype-select-wrap">
              <i className="fa-solid fa-chart-line formtype-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="formtype-filter-select"
                value={performanceFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setPerformanceFilter(e.target.value);
              }}
            >
              <option value="">Performance: Any</option>
              <option value="1">Contributes to performance</option>
                <option value="0">Does not contribute</option>
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading form types...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
                  <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
                  <th className="sortable" onClick={() => handleSort("contributes_to_performance")}>Performance {sortIcon("contributes_to_performance")}</th>
                  <th>System</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {formTypes.length > 0 ? (
                  formTypes.map((formType) => (
                    <tr key={formType.id}>
                      <td>
                        <div className="formtype-name-box">
                          <div className="formtype-letter">
                            {formType.name?.charAt(0)?.toUpperCase() || "F"}
                          </div>

                          <div className="formtype-name-copy">
                            <div className="formtype-name-line">
                              <strong title={formType.name}>{formType.name}</strong>

                              {formType.code === "UAT" && (
                                <Badge className="formtype-uat-badge">
                                  <i className="fa-solid fa-vial-circle-check me-1" aria-hidden="true"></i>
                                  UAT
                                </Badge>
                              )}
                            </div>

                            <small>Form Type ID: {formType.id}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="formtype-code-wrap">
                          <span className="formtype-code-chip">
                            <i className="fa-solid fa-code" aria-hidden="true"></i>
                            {formType.code || "—"}
                          </span>

                          {formType.is_system && (
                            <small className="formtype-protected-note">
                              <i className="fa-solid fa-lock" aria-hidden="true"></i>
                              Protected code
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        {formType.contributes_to_performance ? (
                          <span className="formtype-performance-chip formtype-performance-on">
                            <i className="fa-solid fa-chart-line" aria-hidden="true"></i>
                            Contributes
                          </span>
                        ) : (
                          <span className="formtype-performance-chip formtype-performance-off">
                            <i className="fa-solid fa-minus" aria-hidden="true"></i>
                            No impact
                          </span>
                        )}
                      </td>
                      <td>
                        {formType.is_system ? (
                          <Badge className="unit-status formtype-system-badge">
                            <i className="fa-solid fa-shield-halved me-1" aria-hidden="true"></i>
                            System
                          </Badge>
                        ) : (
                          <span className="formtype-custom-chip">
                            <i className="fa-solid fa-pen-ruler" aria-hidden="true"></i>
                            Custom
                          </span>
                        )}
                      </td>
                      <td>
                        <Badge
                          className={`unit-status ${
                            formType.is_active
                              ? "formtype-status-active"
                              : "formtype-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              formType.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {formType.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="form_types" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label={`Edit ${formType.name || "form type"}`}
                              onClick={() => openEdit(formType)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("form_types", "activate") || can("form_types", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn formtype-toggle ${
                                formType.is_active
                                  ? "formtype-toggle-off"
                                  : "formtype-toggle-on"
                              }`}
                              title={formType.is_active ? "Deactivate" : "Activate"}
                              aria-label={
                                formType.is_active
                                  ? `Deactivate ${formType.name || "form type"}`
                                  : `Activate ${formType.name || "form type"}`
                              }
                              onClick={() => toggleStatus(formType)}
                              disabled={formType.is_system && formType.is_active}
                            >
                              <i className={`fa-solid ${formType.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="form_types" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title={formType.is_system ? "Protected — cannot be deleted" : "Delete"}
                              aria-label={
                                formType.is_system
                                  ? "Protected — cannot be deleted"
                                  : `Delete ${formType.name || "form type"}`
                              }
                              onClick={() => openDeleteModal(formType)}
                              disabled={formType.is_system}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-list-check" aria-hidden="true"></i>
                        </div>
                        <h5>No form types found</h5>
                        <p>Try another search or add a new form type.</p>

                        <Can moduleKey="form_types" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Form Type
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{formTypes.length}</strong> of <strong>{total}</strong> form types
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="formtype-admin-modal formtype-admin-modal-lg"
        backdropClassName="formtype-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="formtype-modal-heading">
            <div className="formtype-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-shapes"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Form Type Setup</small>
              <Modal.Title>{editId ? "Edit Form Type" : "Add New Form Type"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Name</Form.Label>
              <div className="formtype-modal-field">
                <i className="fa-solid fa-shapes" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. Requirement Sign-off"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
              <div className="formtype-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. REQUIREMENT_SIGNOFF"
                  value={form.code}
                  disabled={!!editId}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
              {editIsSystem && (
                <Form.Text className="formtype-system-warning">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                  This is a protected system form type.
                </Form.Text>
              )}
            </div>

            <div className="col-md-12">
              <Form.Label>Description</Form.Label>
              <div className="formtype-modal-field formtype-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-4">
              <Form.Label>Display Order</Form.Label>
              <div className="formtype-modal-field">
                <i className="fa-solid fa-arrow-down-1-9" aria-hidden="true"></i>
                <Form.Control
                  type="number"
                  value={form.display_order}
                  onChange={(e) => handleChange("display_order", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-8">
              <div className="formtype-performance-panel">
                <div className="formtype-performance-panel-icon">
                  <i className="fa-solid fa-chart-line" aria-hidden="true"></i>
                </div>

                <div className="formtype-performance-panel-copy">
                  <Form.Check
                    className="formtype-performance-check"
                    type="checkbox"
                    label="Contributes to performance metrics"
                    checked={form.contributes_to_performance}
                    onChange={(e) => handleChange("contributes_to_performance", e.target.checked)}
                  />

                  <Form.Text muted>
                    Only controls whether a FUTURE submission of this form type may affect performance metrics — no
                    score is ever calculated or applied automatically merely because this is checked.
                  </Form.Text>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Form Type" : "Create Form Type"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="formtype-admin-modal formtype-admin-modal-sm formtype-admin-modal-danger"
        backdropClassName="formtype-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="formtype-modal-heading">
            <div className="formtype-modal-icon formtype-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Form Type</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="formtype-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-shapes"></i>
          </div>

          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If forms reference it, deletion will be blocked — deactivate it instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
